import { ClientType } from '../apollo'
import { types } from '../types'
import gql from 'graphql-tag'

import { findUniqueUserIdentity } from '@dinosband/bv-main-schema/dist/client-gql'

export async function readUserIdentity (client: ClientType, where?: types.UserIdentityWhereUniqueInput): Promise<types.UserIdentity | undefined> {
  try {
    const result = await client.query({
      query: findUniqueUserIdentity,
      variables: {
        where,
      } as types.QueryFindUniqueUserIdentityArgs,
    })
    return result.data.findUniqueUserIdentity
  } catch (e) {
  }
}

const _findFirstUserIdentity = gql`
  query _findFirstUserIdentity($where: UserIdentityWhereInput!, $take: Int, $orderBy: [UserIdentityOrderByWithRelationInput!]) {
    findFirstUserIdentity(where: $where, take: $take, orderBy: $orderBy) {
      id
      name
      idNo
      tel
    }
  }
`

export async function readUserIdentityEx (client: ClientType, where?: types.UserIdentityWhereInput): Promise<types.UserIdentity | undefined> {
  try {
    const result = await client.query({
      query: _findFirstUserIdentity,
      variables: {
        where,
      } as types.QueryFindFirstUserIdentityArgs,
    })
    return result.data.findFirstUserIdentity
  } catch (e) {
  }
}